const Style = ({ attributes, clientId }) => {
	const { columnGap, rowGap, background, padding, border, captionBG, captionTypo, captionColor } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${captionTypo?.googleFontLink ? `@import url(${captionTypo?.googleFontLink})` : ''}

		#ifbInstagramFeed-${clientId} .ifbInstagramFeed{
			${background?.styles || 'background-color: #0000;'}
			padding: ${padding?.styles || '15px 15px'};
			${border?.styles || 'border-radius: 5px;'}
		}
		#ifbInstagramFeed-${clientId} .ifbInstagramFeed .galleryHeader{
			margin-bottom: ${rowGap};
		}
		#ifbInstagramFeed-${clientId} .ifbInstagramFeed .gallery{
			grid-gap: ${rowGap} ${columnGap};
		}
		#ifbInstagramFeed-${clientId} .ifbInstagramFeed .galleryItem figcaption{
			${captionBG?.styles || 'background-color: #0006;'}
		}
		#ifbInstagramFeed-${clientId} .ifbInstagramFeed .galleryItem figcaption p{
			${captionTypo?.styles || 'font-size: 22px;'}
			color: ${captionColor};
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;